// Share only concurrent public-page reads. Completed responses are never cached.
type GuestMatchApi = { getMatchRequest: (userId: string, trackId: string) => Promise<any> }
const pendingByApi = new WeakMap<GuestMatchApi, Map<string, Promise<any>>>()

export function getGuestMatchRequest(api: GuestMatchApi, userId: string, trackId: string, sessionToken: string | null): Promise<any> {
    let pending = pendingByApi.get(api)
    if (!pending) {
        pending = new Map()
        pendingByApi.set(api, pending)
    }
    const key = JSON.stringify([userId, trackId, sessionToken])
    const existing = pending.get(key)
    if (existing) return existing
    const requests = pending
    const request = Promise.resolve().then(() => api.getMatchRequest(userId, trackId)).then(response => {
        requests.delete(key)
        return response
    }, error => {
        requests.delete(key)
        throw error
    })
    requests.set(key, request)
    return request
}
